<section class="py-0 px-0" style="background-color: #d0e9f1;">
    <div class="container-fluid px-0">
        <div class="swiper swiper-product" #productSwiperContainer>
            <div class="swiper-wrapper product-style2">
                <div class="swiper-slide">
                    <div class="product-box style-2 wow fadeInUp" data-wow-delay="0.4s">
                        <div class="product-media">
                            <img src="https://ik.imagekit.io/ezhuthupizhai/banners/1.webp?tr=w-1200"
                                srcset="https://ik.imagekit.io/ezhuthupizhai/banners/1.webp?tr=w-480 480w,https://ik.imagekit.io/ezhuthupizhai/banners/1.webp?tr=w-768 768w,https://ik.imagekit.io/ezhuthupizhai/banners/1.webp?tr=w-1200 1200w,https://ik.imagekit.io/ezhuthupizhai/banners/1.webp?tr=w-1920 1920w"
                                sizes="(max-width: 768px) 100vw, 1920px" alt="Banner 1" width="1920" height="800"
                                fetchpriority="high">
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="product-box style-2 wow fadeInUp" data-wow-delay="0.4s">
                        <div class="product-media">
                            <img src="https://ik.imagekit.io/ezhuthupizhai/banners/3.webp?updatedAt=1757317910120"
                                alt="Banner 2" width="1920" height="800" loading="lazy">
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="product-box style-2 wow fadeInUp" data-wow-delay="0.4s">
                        <div class="product-media">
                            <img src="https://ik.imagekit.io/ezhuthupizhai/banners/2.webp?updatedAt=1757317909598"
                                alt="Banner 3" width="1920" height="800" loading="lazy">
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
<app-products></app-products>

<section class="content-inner-3 overflow-hidden bg-light">
    <div class="dz-features-wrapper overflow-hidden">
        <ul class="dz-features text-wrapper">
            <li class="item">
                <h2 class="title">Ezhuthupizhai</h2>
            </li>
            <li class="item">
                <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                    <path opacity="0.3"
                        d="M29.302 -0.00499268L38.533 21.2005L60.3307 28.9297L39.1253 38.1607L31.396 59.9585L22.165 38.753L0.367297 31.0237L21.5728 21.7928L29.302 -0.00499268Z"
                        fill="black" />
                </svg>
            </li>
            <li class="item">
                <h2 class="title">Mittaai Payal</h2>
            </li>
            <li class="item">
                <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                    <path opacity="0.3"
                        d="M29.302 -0.00499268L38.533 21.2005L60.3307 28.9297L39.1253 38.1607L31.396 59.9585L22.165 38.753L0.367297 31.0237L21.5728 21.7928L29.302 -0.00499268Z"
                        fill="black" />
                </svg>
            </li>
            <li class="item">
                <h2 class="title">Kannamma</h2>
            </li>
            <li class="item">
                <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                    <path opacity="0.3"
                        d="M29.302 -0.00499268L38.533 21.2005L60.3307 28.9297L39.1253 38.1607L31.396 59.9585L22.165 38.753L0.367297 31.0237L21.5728 21.7928L29.302 -0.00499268Z"
                        fill="black" />
                </svg>
            </li>
            <li class="item">
                <h2 class="title">Oru Tea Sapdalama</h2>
            </li>
            <li class="item">
                <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                    <path opacity="0.3"
                        d="M29.302 -0.00499268L38.533 21.2005L60.3307 28.9297L39.1253 38.1607L31.396 59.9585L22.165 38.753L0.367297 31.0237L21.5728 21.7928L29.302 -0.00499268Z"
                        fill="black" />
                </svg>
            </li>
            <li class="item">
                <h2 class="title">Kan Simittal</h2>
            </li>
            <li class="item">
                <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                    <path opacity="0.3"
                        d="M29.302 -0.00499268L38.533 21.2005L60.3307 28.9297L39.1253 38.1607L31.396 59.9585L22.165 38.753L0.367297 31.0237L21.5728 21.7928L29.302 -0.00499268Z"
                        fill="black" />
                </svg>
            </li>
        </ul>
    </div>
</section>

<section class="about-style4 overflow-hidden" style="background-color: #d0e9f1;">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 aos-item wow fadeInUp" data-wow-delay="0.3s">
                <div class="">
                    <div class="section-head style-2 d-block">
                        <h3 class="title w-100">About the Author</h3>
                        <p class="noto-sans-tamil" style="font-size: 14px;">
                            சொந்த ஊர் திருவாரூர் மாவட்டம் ராஜமன்னார்குடி. சென்னை கிண்டி பொறியியல் கல்லூரியில் M.Sc.
                            IT
                            (Integrated 5 Years), BITS PILANI-யில் MBA (Digital Business) பயின்றவர்.
                        </p>
                        <p class="noto-sans-tamil" style="font-size: 14px;">
                            நான்கு வருடம் தொழில்நுட்பத் துறையில் பணியாற்றிவிட்டு தற்போது சென்னை அடையாறில் GOD
                            PARTICLES
                            என்கிற விளம்பர வடிவமைப்பு நிறுவனத்தை நடத்தி வருகிறார். இந்தியா, ஆஸ்திரேலியா, அமெரிக்கா,
                            லண்டன், சிங்கப்பூர், ஜெர்மனி, ஸ்ரீலங்கா முதலிய நாடுகளில் அமைந்திருக்கும் பல்வேறு
                            நிறுவனங்களுக்கு விளம்பர வடிவமைப்பு சேவையைச் செய்து வருகிறது GOD PARTICLES.
                        </p>
                        <p class="noto-sans-tamil" style="font-size: 14px;">
                            தனது 'எழுத்துப்பிழை' என்னும் முதல் புத்தகத்திற்கு கிடைத்த வரவேற்பின் காரணமாக தன்னுடைய
                            சுய
                            பிரசுர குழுவிற்கு 'எழுத்துப்பிழை பதிப்பகம்' என்று பெயரிட்டார். 'எழுத்துப்பிழை'யின் கீழ்
                            'ஒரு
                            டீ சாப்டலாமா?' என்னும் கதைக் குழு ஒன்று நடத்தி வருகிறார். மாதாந்திர நிகழ்வாக 'ஒரு டீ
                            சாப்டலாமா?' நடத்தப்படுகிறது.
                        </p>
                        <p class="noto-sans-tamil" style="font-size: 14px;">
                            எழுத்துப்பிழை, விகடகவி, கண்ணம்மா, கண் சிமிட்டல், ஒரு டீ சாப்டலாமா ஆகிய புத்தகங்களைத்
                            தொடர்ந்து 'மையல்' என்னும் சிறுகதைத் தொகுப்பையும் 'நதி' என்னும் நாவலையும் விரைவில்
                            வெளியிட
                            இருக்கிறார்.
                        </p>
                    </div>
                    <div class="about-bx-detail">
                        <div>
                            <h6 class="name">மனோபாரதி</h6>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="side-content">
                    <div class="about-thumb" style="aspect-ratio: 510 / 689;">
                        <img src="https://ik.imagekit.io/ezhuthupizhai/banners/author.webp?updatedAt=1757318224726"
                            alt="மனோபாரதி" width="510" height="689" style="width: 100%; height: auto; display: block;"
                            loading="eager" fetchpriority="high" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="content-inner-3 overflow-hidden"
    style="background-image: url(https://ik.imagekit.io/ezhuthupizhai/banners/map2.webp?updatedAt=1757318540547);">
    <div class="container">
        <div class="row align-items-start">
            <h2 class="fs-1 mb-4 text-center">Shop In-Store</h2>
            <ng-container *ngIf="vendors && vendors.length > 0">
                <div class="col-xl-4 col-lg-4 col-md-4 col-12" *ngFor="let vendor of vendors | slice:0:3">
                    <div class="pricingtable-wrapper bg-light style-1 bg-light mb-3">
                        <div class="pricingtable-inner">
                            <div class="pricingtable-title">
                                <img [src]="vendor.flag" alt="{{ vendor.name }} flag" width="40" height="27"
                                    loading="lazy"
                                    style="position: absolute; top: 15px; right: 20px; border: 1px solid black;" />

                                <img *ngIf="vendor.logo" [src]="vendor.logo" alt="{{ vendor.name }} logo"
                                    class="vendor-logo mb-4" width="200" height="100" loading="lazy"
                                    style="width: 200px;" />

                                <h3 class="title fs-3">{{ vendor.name }}</h3>
                                <p class="text-black">
                                    Location : {{ vendor.address_line1 }}, {{ vendor.address_line2 }}, {{
                                    vendor.city
                                    }}, {{
                                    vendor.state }} - {{ vendor.pincode }}
                                </p>
                                <a *ngIf="vendor.phone" [href]="'tel:' + vendor.phone" class="fs-3 read-btn">
                                    <i class="fa-solid fa-phone me-2"></i> {{ vendor.phone }}</a>
                                <p *ngIf="!vendor.phone" class="font-15 read-btn">
                                    Call: Not Available
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="col-12 text-center mt-4">
                <a href="/shop-in-store" class="btn btn-theme text-uppercase">More Details<i
                        class="fa-solid fa-arrow-right"></i></a>
            </div>
        </div>
    </div>
</section>

<section class="adv-area"
    style="background-image: url('https://ik.imagekit.io/ezhuthupizhai/bulk-bg.jpeg?updatedAt=1760360545267'); background-size: cover;background-position: top;">
    <div class="container-fluid px-0">
        <div class="row product-style2 g-0">
            <div class="col-9 col-lg-10 col-md-10">
                <div class="product-box style-4">
                    <div class="product-content">
                        <div class="main-content w-100 text-start">
                            <h2 class="fs-2 fs-15">
                                10 க்கும் மேற்பட்ட மொத்த ஆர்டர்களுக்கு, சிறப்பு விலையில்,<br>
                                எழுத்துப்பிழை புத்தகங்கள்.
                            </h2>
                            <a href="tel: +91 99627 00810" class="btn btn-theme text-uppercase">Call us
                                <i class="fa-solid fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="content-inner-3 py-0 pb-4">
    <div class="container">
        <div class="row g-lg-4 g-3 m-3">
            <div class="col-lg-12 col-md-12 wow fadeInUp" data-wow-delay="0.1s">
                <h2 class="fs-1 mb-4 text-center">Poetry in Frames</h2>
            </div>
            <ng-container *ngIf="videos && videos.length > 0">
                <div class="col-xl-4 col-md-4 col-sm-4 col-12" *ngFor="let video of videos | slice:0:3">
                    <div class="dz-media video-container">
                        <video [poster]="video.thumb_url" controls loop muted playsinline class="w-100 h-100"
                            [attr.data-src]="video.video_url" width="640" height="360">
                        </video>
                    </div>
                </div>
            </ng-container>
            <div class="col-lg-12 col-md-12 text-center" *ngIf="!videos || videos.length === 0">
                <p>No videos found at this time.</p>
            </div>
        </div>
    </div>
</section>

<section class="content-inner-3 py-0 pb-4">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 wow fadeInUp" data-wow-delay="0.1s">
                <h2 class="fs-1 mb-4 text-center">Poetry in Pixels</h2>
            </div>
        </div>

        <ul id="masonry" class="lightgallery row" *ngIf="randomImages.length > 0 && !loading">
            <li class="card-container col-xl-3 col-lg-3 col-md-6 col-sm-6 m-b30" *ngFor="let item of randomImages">
                <div class="portfolio-box style-2">
                    <div class="dz-media">
                        <img [src]="item.gallery_image" alt="Poetry in Pixels image" width="400" height="400"
                            loading="lazy">
                    </div>
                </div>
            </li>
        </ul>

        <div class="col-lg-12 col-md-12 text-center" *ngIf="!gallery || gallery.length === 0">
            <p>No images found at this time.</p>
        </div>
        <div class="col-12 text-center mt-4">
            <a href="gallery" class="btn btn-theme text-uppercase">More Gallery
                <i class="fa-solid fa-arrow-right"></i>
            </a>
        </div>
    </div>
</section>